import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export function apiError(err, fallback = "Something went wrong. Please try again.") {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg?.replace(/^Value error, /, "") || "").filter(Boolean).join(" ");
  return detail?.msg || fallback;
}

export const submitQuote = (payload) => api.post("/quotes", payload).then((r) => r.data);
export const getProjects = () => api.get("/projects").then((r) => r.data);
export const getSiteImages = () => api.get("/site-images").then((r) => r.data);
export const siteImageUrl = (slot, version) => `${process.env.REACT_APP_BACKEND_URL}/api/site-images/${slot}?v=${encodeURIComponent(version || "")}`;
export const projectImageUrl = (id, version) => `${process.env.REACT_APP_BACKEND_URL}/api/projects/${id}/image?v=${encodeURIComponent(version || "")}`;
export const projectGalleryUrl = (id, imageId) => `${process.env.REACT_APP_BACKEND_URL}/api/projects/${id}/images/${imageId}`;

export const pay = {
  invoice: (token) => api.get(`/pay/${token}`).then((r) => r.data),
  checkout: (token) => api.post(`/pay/${token}/checkout`, { origin_url: window.location.origin }).then((r) => r.data),
  status: (sessionId) => api.get(`/pay/status/${sessionId}`).then((r) => r.data),
};
export const payLinkFor = (inv) => `${window.location.origin}/pay/${inv.pay_token}`;

const multipart = { headers: { "Content-Type": "multipart/form-data" } };

export const admin = {
  login: (password) => api.post("/admin/login", { password }).then((r) => r.data),
  logout: () => api.post("/admin/logout").then((r) => r.data),
  me: () => api.get("/admin/me").then((r) => r.data),
  changePassword: (body) => api.post("/admin/change-password", body).then((r) => r.data),
  siteInfo: () => api.get("/admin/site-info").then((r) => r.data),
  stats: () => api.get("/admin/quotes/stats").then((r) => r.data),
  quotes: (params) => api.get("/admin/quotes", { params }).then((r) => r.data),
  quote: (id) => api.get(`/admin/quotes/${id}`).then((r) => r.data),
  update: (id, body) => api.patch(`/admin/quotes/${id}`, body).then((r) => r.data),
  remove: (id) => api.delete(`/admin/quotes/${id}`).then((r) => r.data),
  projects: () => api.get("/admin/projects").then((r) => r.data),
  createProject: (formData) => api.post("/admin/projects", formData, multipart).then((r) => r.data),
  updateProject: (id, formData) => api.patch(`/admin/projects/${id}`, formData, multipart).then((r) => r.data),
  reorderProjects: (ids) => api.post("/admin/projects/reorder", { ids }).then((r) => r.data),
  deleteProject: (id) => api.delete(`/admin/projects/${id}`).then((r) => r.data),
  siteImages: () => api.get("/admin/site-images").then((r) => r.data),
  uploadSiteImage: (slot, formData) => api.post(`/admin/site-images/${slot}`, formData, multipart).then((r) => r.data),
  resetSiteImage: (slot) => api.delete(`/admin/site-images/${slot}`).then((r) => r.data),
  invoices: (params) => api.get("/admin/invoices", { params }).then((r) => r.data),
  invoice: (id) => api.get(`/admin/invoices/${id}`).then((r) => r.data),
  invoicePrefill: (quoteId, stage = "standard") => api.get("/admin/invoices/prefill", { params: { quote_id: quoteId, stage } }).then((r) => r.data),
  invoiceServices: () => api.get("/admin/invoices/services").then((r) => r.data),
  createInvoice: (body) => api.post("/admin/invoices", body).then((r) => r.data),
  updateInvoice: (id, body) => api.put(`/admin/invoices/${id}`, body).then((r) => r.data),
  duplicateInvoice: (id) => api.post(`/admin/invoices/${id}/duplicate`).then((r) => r.data),
  markInvoicePaid: (id, amount) => api.post(`/admin/invoices/${id}/mark-paid`, { amount_paid: amount ?? null }).then((r) => r.data),
  setInvoiceStatus: (id, status) => api.post(`/admin/invoices/${id}/status`, { status }).then((r) => r.data),
  deleteInvoice: (id) => api.delete(`/admin/invoices/${id}`).then((r) => r.data),
  sendInvoice: (id, body) => api.post(`/admin/invoices/${id}/send`, { ...body, origin_url: window.location.origin }).then((r) => r.data),
  invoiceEmails: (id) => api.get(`/admin/invoices/${id}/emails`).then((r) => r.data),
  invoicePdf: (id) => api.get(`/admin/invoices/${id}/pdf`, { responseType: "blob", params: { origin: window.location.origin } }).then((r) => r.data),
  invoiceSettings: () => api.get("/admin/invoices/settings").then((r) => r.data),
  saveInvoiceSettings: (body) => api.put("/admin/invoices/settings", body).then((r) => r.data),
};

export default api;
